// removed by extract-text-webpack-plugin
module.exports = {"today_in_previous_years":"today_in_previous_years__IJE9A"};


//////////////////
// WEBPACK FOOTER
// ./components/today-in-previous-years/style.scss
// module id = MBDq
// module chunks = 0